<div class="pb-7 pt-0">
  <div class="p-2_5">
    <div class="text-center pb-2">
      <p-avatar
        [class.cursor-pointer]="false"
        [class.clickable]="false"
        [image]="playerProfile.pictureUrl"
        [size]="'large'"
        [shape]="'square'"/>
    </div>

    <textarea pTextarea id="comment" [rows]="3" [(ngModel)]="text" style="width: 100%"
              [placeholder]="'REPORT_PICTURE_TEXT_HINT' | translate"></textarea>


    <div class="pt-2">
      {{'NAME' | translate}} ({{'OPTIONAL' | translate}})
    </div>
    <input pInputText id="name" [(ngModel)]="name" type="text" class="p-inputtext w-full" [maxlength]="200" >

    <div class="pt-2">
      {{'CONTACT_EMAILADDRESS' | translate}} ({{'OPTIONAL' | translate}})
    </div>
    <input pInputText id="mail" [(ngModel)]="mail" type="email" class="p-inputtext w-full" [maxlength]="200" >

    <p-divider />
    <div>
      {{'REPORT_PICTURE_TERMS' | translate}}
    </div>
    <div class="py-2 md:py-3">
      <app-checkbox [(value)]="policyAccepted" [label]="'ACCEPT_TERMS_AND_CONDITIONS' | translate"
                    classLabel="font-bold"/>
    </div>
  </div>
</div>

<div class="dialog-footer flex">
  <app-dialog-button [loading]="isSaving"
                     [labelOkButton]="'REPORT_PICTURE' | translate"
                     [okButtonDisabled]="isSaving || !policyAccepted || !text"
                     (onOkClicked)="onOkClicked()"
                     (onCancelClicked)="onCancelClicked()"/>
</div>
